import { render, staticRenderFns } from "./ed-lesson-create-link.vue?vue&type=template&id=1f2d5cfb&scoped=true&"
import script from "./ed-lesson-create-link.ts?vue&type=script&lang=ts&"
export * from "./ed-lesson-create-link.ts?vue&type=script&lang=ts&"
import style0 from "./ed-lesson-create-link.scss?vue&type=style&index=0&id=1f2d5cfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d5cfb",
  null
  
)

export default component.exports